import { API } from "@/lib/api";
import { trackUmamiEvent } from "@/lib/umamiAnalytics";

const ANALYTICS_ENDPOINT = `${API}/public/analytics`;

function trimValue(value, maxLength = 120) {
  const normalized = typeof value === "string" ? value.trim() : "";
  if (!normalized) return undefined;
  return normalized.slice(0, maxLength);
}

function buildPayload(eventName, payload = {}) {
  if (typeof window === "undefined") return null;

  return {
    event_name: eventName,
    page_path: trimValue(payload.page_path || window.location.pathname, 300) || "/",
    source: trimValue(payload.source || "landing", 40) || "landing",
    section: trimValue(payload.section, 80),
    cta_id: trimValue(payload.cta_id, 80),
    faq_id: trimValue(payload.faq_id, 120),
    referrer: trimValue(payload.referrer || document.referrer, 500),
  };
}

function umamiEventName(eventName, body) {
  if (eventName === "page_view" && body.source === "landing") return "landing_viewed";
  if (eventName === "cta_click" && body.cta_id === "request_beta") {
    return body.source === "demo" ? "demo_beta_request_clicked" : "beta_request_clicked";
  }
  return eventName;
}

export function trackPublicEvent(eventName, payload = {}) {
  const body = buildPayload(eventName, payload);
  if (!body) return;

  trackUmamiEvent(umamiEventName(eventName, body), {
    page_path: body.page_path,
    source: body.source,
    section: body.section,
    cta_id: body.cta_id,
    faq_id: body.faq_id,
    use_case: trimValue(payload.use_case, 40),
  });

  const raw = JSON.stringify(body);
  if (navigator.sendBeacon) {
    const blob = new Blob([raw], { type: "application/json" });
    navigator.sendBeacon(ANALYTICS_ENDPOINT, blob);
    return;
  }

  fetch(ANALYTICS_ENDPOINT, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: raw,
    keepalive: true,
  }).catch(() => {});
}
